import clsx from 'clsx';
import { HTMLInputTypeAttribute, RefCallback } from 'react';

import commonStyles from '../Common.module.scss';

import { Typography } from '@/components/core';
import { InputFormStoryblok } from '@/types/storyblok/storyblok-types';

import styles from './InputForm.module.scss';

export type FormControllerProps = {
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onClick?(e: any): void;
    onBlur?(e: any): void;
    value: string;
    ref: RefCallback<HTMLInputElement | HTMLTextAreaElement>;
};

type InputFormProps = {
    blok: InputFormStoryblok;
    props: FormControllerProps;
    type?: HTMLInputTypeAttribute;
    error?: any | null;
    isTouched?: boolean;
    required?: boolean;
    className?: string;
};

export const InputFormClient: React.FC<InputFormProps> = ({
    blok,
    props,
    type,
    error,
    required,
    isTouched,
    className,
}) => {
    const { label, placeholder, width } = blok;
    return (
        <div
            className={clsx(commonStyles.root, styles.inputForm, {
                [commonStyles.halfWidth]: width === '50%',
            })}
        >
            <div>
                <label className={clsx(commonStyles.label, 'label')}>{label}</label>
                {required && <span className={commonStyles.asterix}>*</span>}
            </div>

            {type === 'textarea' ? (
                <textarea
                    className={clsx(commonStyles.input, styles.textarea, className)}
                    ref={props.ref}
                    placeholder={placeholder}
                    {...props}
                />
            ) : (
                <input
                    ref={props.ref}
                    className={clsx(commonStyles.input, className)}
                    type={type || 'text'}
                    placeholder={placeholder}
                    {...props}
                />
            )}

            {error && isTouched && (
                <Typography
                    looksLike="pSmall"
                    className={styles.error}
                >
                    {error.message}
                </Typography>
            )}
        </div>
    );
};
